import React, { useEffect, useRef, useState } from "react";
import {
  ChevronDown,
  ChevronUp,
  MoreHorizontal,
  UserCheck,
  UserX,
  Edit,
  Trash2,
  Check,
  X,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";
import { FiMoreVertical } from "react-icons/fi";
import DeclineSenderModal from "./DeclineSenderModal";
import ActivateSenderModal from "./ActivateSenderModal";
import { motion } from "framer-motion";
import moment from "moment";
const SenderTableComponent = ({
  data,
  searchTerm,
  sortConfig,
  onSort,
  onSuccess,
  onError,
  onSelectedRowsChange,
}) => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const dropdownRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [showDeclineModal, setShowDeclineModall] = useState(false);
  const [showActivateModal, setShowActivateModal] = useState(false);
  const [type, setType] = useState("");
  const [selectedSender, setSelectedSender] = useState(null);
  const [senderId, setSenderId] = useState(null);

  console.log("data",data)

  const columns = [
    {
      key: "id",
      label: "ID",
    },
    {
      key: "name",
      label: "Sender ID",
    },
    {
      key: "businessName",
      label: "Business Name",
    },
    {
      key: "email",
      label: "Email",
    },
    {
      key: "phone",
      label: "Phone",
    },
    {
      key: "dateCreated",
      label: "Date Created",
    },
    {
      key: "status",
      label: "Status",
    },
  ];

  const handleSelectAll = (e) => {
    const newSelection = e.target.checked
      ? filteredData.map((row) => row.id)
      : [];
    setSelectedRows(newSelection);
    onSelectedRowsChange(newSelection);
  };

  const handleSelectRow = (id) => {
    setSelectedRows((prev) => {
      const newSelection = prev.includes(id)
        ? prev.filter((rowId) => rowId !== id)
        : [...prev, id];
      onSelectedRowsChange(newSelection);
      return newSelection;
    });
  };

  const getSortIcon = (columnKey) => {
    if (sortConfig.key === columnKey) {
      return sortConfig.direction === "ascending" ? (
        <ChevronUp className="w-3 h-3" />
      ) : (
        <ChevronDown className="w-3 h-3" />
      );
    }
    return <ChevronDown className="w-3 h-3 text-gray-300" />;
  };

  // Filter data based on search term
  const filteredData = data.filter((row) => {
    if (!searchTerm) return true;
    return Object.values(row)
      .join(" ")
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
  });

  // Sort data based on sortConfig
  const sortedData = [...filteredData].sort((a, b) => {
    if (!sortConfig.key) {
      // Default sort by dateCreated descending (newest first)
      return new Date(b.dateCreated || b.created_at) - new Date(a.dateCreated || a.created_at);
    }

    const aValue = a[sortConfig.key];
    const bValue = b[sortConfig.key];

    // Handle date sorting specifically
    if (sortConfig.key === 'dateCreated' || sortConfig.key === 'created_at') {
      const dateA = new Date(aValue);
      const dateB = new Date(bValue);
      return sortConfig.direction === 'ascending' 
        ? dateA - dateB 
        : dateB - dateA;
    }

    // Handle string/number sorting
    if (aValue < bValue) {
      return sortConfig.direction === 'ascending' ? -1 : 1;
    }
    if (aValue > bValue) {
      return sortConfig.direction === 'ascending' ? 1 : -1;
    }
    return 0;
  });

  const getStatusStyle = (status) => {
    const styles = {
      Approved: "bg-green-50 text-green-700 border-green-100",
      Pending: "bg-yellow-50 text-yellow-700 border-yellow-100",
      Rejected: "bg-red-50 text-red-700 border-red-100",
      Inactive: "bg-gray-50 text-gray-700 border-gray-100",
    };
    return styles[status] || "bg-gray-50 text-gray-700 border-gray-100";
  };

  const toggleDropdown = (id) => {
    setOpenDropdownId(openDropdownId === id ? null : id);
  };

  // Pagination
  const totalPages = Math.ceil(sortedData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = sortedData.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const handleDecline = (sender, type) => {
    setType(type);
    setSelectedSender(sender);
    setSenderId(sender.sender_slug);
    setShowDeclineModall(true);
  };

  const handleAccept = (sender, type) => {
    setType(type);
    setSelectedSender(sender);
    setSenderId(sender.sender_slug);
    setShowActivateModal(true);
  };

  const handleClickOutside = (event) => {
    if (
      dropdownRef.current &&
      openDropdownId &&
      !event.target.closest(".action-dropdown")
    ) {
      setOpenDropdownId(null);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [openDropdownId]);

  return (
    <div>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="sticky top-0 z-20 bg-gray-50">
            <tr>
              <th className="sticky left-0 p-3 w-10 bg-gray-50">
                <div className="inline-flex relative items-center">
                  <input
                    type="checkbox"
                    className="peer h-4 w-4 appearance-none rounded border border-gray-300 checked:border-[#FF6C6C] checked:bg-[#FF6C6C] hover:border-[#FF6C6C] focus:outline-none focus:ring-2 focus:ring-[#FF6C6C]/50"
                    onChange={handleSelectAll}
                    checked={
                      selectedRows.length === filteredData.length &&
                      filteredData.length > 0
                    }
                  />
                  <Check className="absolute top-1/2 left-1/2 w-3 h-3 text-white opacity-0 -translate-x-1/2 -translate-y-1/2 pointer-events-none peer-checked:opacity-100" />
                </div>
              </th>
              {columns.map((column) => (
                <th
                  key={column.key}
                  className="px-3 py-2 text-xs font-medium tracking-wider text-center text-gray-500 uppercase cursor-pointer text-nowrap hover:bg-gray-100"
                  onClick={() => onSort(column.key)}
                >
                  <div className="flex gap-1 items-center">
                    {column.label} {getSortIcon(column.key)}
                  </div>
                </th>
              ))}
              <th className="px-4 py-2 text-xs font-medium text-right text-gray-700 uppercase">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {paginatedData.map((row, index) => (
              <motion.tr
                key={row.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.05 }}
                className="hover:bg-gray-50"
              >
                <td className="px-4 py-2 whitespace-nowrap">
                  <div className="inline-flex relative items-center">
                    <input
                      type="checkbox"
                      className="peer h-4 w-4 appearance-none rounded border border-gray-300 checked:border-[#FF6C6C] checked:bg-[#FF6C6C] hover:border-[#FF6C6C] focus:outline-none focus:ring-2 focus:ring-[#FF6C6C]/50"
                      checked={selectedRows.includes(row.id)}
                      onChange={() => handleSelectRow(row.id)}
                    />
                    <Check className="absolute top-1/2 left-1/2 w-3 h-3 text-white opacity-0 -translate-x-1/2 -translate-y-1/2 pointer-events-none peer-checked:opacity-100" />
                  </div>
                </td>
                <td className="px-3 py-3 text-sm font-medium text-gray-700 whitespace-nowrap">
                  {row.id}
                </td>
                <td className="px-6 py-4 text-sm text-gray-700 whitespace-nowrap"> {row.sender} </td>
                <td className="px-6 py-4 text-sm text-gray-700 whitespace-nowrap">
                  {row.vendor.brand_name}
                </td>
                <td className="px-6 py-4 text-sm text-gray-700 whitespace-nowrap"> {row.vendor.email} </td>
                <td className="px-6 py-4 text-sm text-gray-700 whitespace-nowrap">
                  +{row.vendor.phone_number}{" "}
                </td>
                <td className="px-6 py-4 text-sm text-gray-700 whitespace-nowrap">
                  {moment(row.created_at).format("DD-MMM-YYYY")}
                </td>
                <td className="px-6 py-4 text-sm text-gray-700 whitespace-nowrap">
                  <span
                    className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${getStatusStyle(
                      row.status
                    )}`}
                  >
                    {row.status === "Approved"
                      ? "Approved"
                      : row.status === "Rejected"
                      ? "Rejected"
                      : row.status === "Pending"
                      ? "Pending"
                      : ""}
                  </span>
                </td>
                <td className="px-6 py-4 text-right whitespace-nowrap">
                  <div className="relative action-dropdown" ref={dropdownRef}>
                    <button
                      onClick={() => toggleDropdown(row.id)}
                      className="z-0 p-1 rounded-full hover:bg-gray-100"
                    >
                      <FiMoreVertical className="w-4 h-4 text-gray-700" />
                    </button>
                    {openDropdownId === row.id && (
                      <div className="absolute right-0 bottom-full z-50 mt-1 w-48 bg-white rounded-md ring-1 ring-black ring-opacity-5 shadow-lg">
                        <div className="py-1">
                          {row.status === "Pending" ? (
                            <>
                              <button
                                className="flex items-center px-4 py-2 w-full text-xs text-gray-700 hover:bg-gray-100"
                                onClick={() => handleAccept(row, "active")}
                              >
                                <Check className="mr-2 w-4 h-4 text-green-500" />
                                Accept
                              </button>
                              <button
                                className="flex items-center px-4 py-2 w-full text-xs text-gray-700 hover:bg-gray-100"
                                onClick={() => handleDecline(row, "decline")}
                              >
                                <X className="w-4 h-4 mr-2 text-[#FF6C6C]" />
                                Decline
                              </button>
                            </>
                          ) : (
                            <>
                              {row.status === "Approved" && (
                                <button
                                  className="flex items-center px-4 py-2 w-full text-xs text-gray-700 hover:bg-gray-100"
                                  onClick={() => handleDecline(row, "suspend")}
                                >
                                  <UserX className="mr-2 w-4 h-4 text-red-500" />
                                  Suspend
                                </button>
                              )}
                              {row.status === "Rejected" && (
                                <>
                                  <button
                                    className="flex items-center px-4 py-2 w-full text-xs text-gray-700 hover:bg-gray-100"
                                    onClick={() => handleAccept(row, "active")}
                                  >
                                    <UserCheck className="mr-2 w-4 h-4 text-green-500" />
                                    Activate
                                  </button>
                                </>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </td>
              </motion.tr>
            ))}
          </tbody>
        </table>
      </div>
      {filteredData.length === 0 && (
        <div className="py-8 text-center">
          <p className="text-sm text-gray-700">No senders found</p>
        </div>
      )}
      {filteredData.length > 0 && (
        <div className="px-6 py-3 bg-gray-50">
          <div className="flex justify-between items-center">
            <p className="text-sm text-gray-700">
              Showing {startIndex + 1} to{" "}
              {Math.min(startIndex + itemsPerPage, sortedData.length)} of{" "}
              {sortedData.length} results
            </p>

            <div className="flex items-center space-x-2">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className="p-2 rounded-md bg-[#FF6C6C] text-white border disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <ChevronLeft className="w-4 h-4" />
              </button>
              <span className="text-sm">
                {currentPage} of {totalPages}
              </span>
              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
                className="p-2 rounded-md bg-[#FF6C6C] text-white border disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <ChevronRight className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      )}

      <DeclineSenderModal
        isOpen={showDeclineModal}
        onClose={() => setShowDeclineModall(false)}
        sender={selectedSender}
        onSuccess={onSuccess}
        onError={onError}
        senderId={senderId}
        type={type}
      />

      {showActivateModal && (
        <ActivateSenderModal
          isOpen={showActivateModal}
          onClose={() => setShowActivateModal(false)}
          sender={selectedSender}
          onSuccess={onSuccess}
          onError={onError}
          senderId={senderId}
          type={type}
        />
      )}
    </div>
  );
};

export default SenderTableComponent;